<template>
  <div class="ti-tooltip">
    <div class="ti-tooltip__content">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fill-rule="evenodd">
          <path class="info-i-circle" d="M9 1a8 8 0 110 16A8 8 0 019 1z" />
          <path
            class="info-i-letter"
            d="M9.766 7.606H7.491v.926h1.053v3.376H7.407v.925h3.258v-.925h-.899zM8.995 4.833a.948.948 0 00-.941.955c0 .527.421.954.94.954.52 0 .942-.427.942-.954a.948.948 0 00-.941-.955z"
          />
        </g>
      </svg>

      <div class="ti-tooltip__copy" v-if="text">
        <I18n :path="$t(text)">
          <template #vinLink>
            <a
              class="wb-link wb-link--inline"
              @click="getStep('vinidentification')"
              >{{ $t('i18n.links.vinLink') }}</a
            >
          </template>
        </I18n>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import I18n from '../i18n/i18n.vue';
defineProps<{
  text: string;
}>();
const emit = defineEmits(['getStep']);

const getStep = (stepId: string): void => {
  emit('getStep', stepId);
};
</script>

<style lang="scss">
.ti-tooltip {
  max-height: 200px;
  @include wb-spacing('margin', 'xxs 0 xs 0');

  &__content {
    display: flex;
    flex-flow: row nowrap;

    > svg {
      flex-shrink: 0;
      width: 16px;
      height: 16px;

      .info-i-circle {
        stroke: var(--wb-grey-45);
      }

      .info-i-letter {
        fill: var(--wb-grey-45);
      }
    }
  }

  &__copy {
    @include wb-type-hint;
    @include wb-spacing('padding-left', 'xxs');

    color: var(--wb-grey-45);

    .wb-link {
      color: var(--wb-grey-45);
      border-bottom: 1px solid currentColor;
    }
  }
}
</style>
